import React from 'react'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import PaginationButtons from '../../../../PaginationButtons'
import FhirLoader from '../../../../FhirLoader'
import { buildExtSlices } from '../../../../../utils/helpers'
import { MedicationKnowledgeTable } from '@teschglobal/tg-fhir-react-components'
import { MedicationKnowledge, CombinedMedicationKnowledge } from '@teschglobal/tg-fhir-react-components/dist/types'
import { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'

type MedicationKnowledgeListProps = {
  medicationKnowledges: ProviderResponse<MedicationKnowledge>
  clickViewDataLink: (medicationKnowledge: MedicationKnowledge) => void
  isFetching: boolean
  isLoading: boolean
  isSuccess: boolean
  totalPages: number
  currentPage: number
  handleChangePage: (page: number) => void
}

const MedicationKnowledgeList: React.FC<MedicationKnowledgeListProps> = ({
  medicationKnowledges,
  clickViewDataLink,
  isFetching,
  isLoading,
  totalPages,
  currentPage,
  handleChangePage
}) => {
  const { data: environment } = useEnvironment()

  const rows: CombinedMedicationKnowledge[] =
    medicationKnowledges?.data?.map((resource) => {
      const extSlices = buildExtSlices(
        (resource.extension ?? []) as any,
        'MedicationKnowledge'
      )
      return { ...resource, ...extSlices } as CombinedMedicationKnowledge
    }) ?? []

  return (
    <>
      <h3>MedicationKnowledge</h3>

      {(isLoading || isFetching) ? (
        <FhirLoader message='Loading...' />
      ) : (
        <>
          {medicationKnowledges?.total > 0 &&
            environment?.includeTotalInFHIRRequest && (
              <div className='my-3 fw-bold'>
                <span role="status" aria-live="polite">
                  {medicationKnowledges.total.toLocaleString()} record(s) found
                </span>

                <PaginationButtons
                  totalPages={totalPages}
                  currentPage={currentPage}
                  handleChangePage={handleChangePage}
                />
              </div>
            )}

          <MedicationKnowledgeTable
            medicationKnowledges={rows}
            onRowLinkClick={clickViewDataLink}
          />

          {medicationKnowledges?.total > 0 &&
            environment?.includeTotalInFHIRRequest && (
              <div className='my-3 fw-bold'>
                <PaginationButtons
                  totalPages={totalPages}
                  currentPage={currentPage}
                  handleChangePage={handleChangePage}
                />
              </div>
            )}
        </>
      )}
    </>
  )
}

export default MedicationKnowledgeList